import {apiClient} from "@/services/auth-header";
import { STORAGE_KEYS } from "@/common/common-enum";

const API_URL = '/v1/auth';

class AuthService {
    login(reqDto) {
        return apiClient
            .post(API_URL + '/login', {
                accountId: reqDto.accountId,
                accountPwd: reqDto.accountPwd
            })
            .then(response => {
                if (response.data.accessToken) {
                    localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(response.data));
                }
                return response.data;
            });
    }

    logout() {
        localStorage.removeItem(STORAGE_KEYS.USER);
        localStorage.removeItem(STORAGE_KEYS.MENU);
    }
}

export default new AuthService();
